import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import * as React from "react";

export default function AnnoucementTabs({ value, handleChange }: { value: number; handleChange: (e: React.SyntheticEvent, newValue: number) => void }) {
  return (
    <Box sx={{ py: 0.5, display: 'flex' }}>
      <Box
        sx={{
          display: 'inline-flex',
          backgroundColor: (theme) =>
            theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : '#f1f5f9',
          border: (theme) =>
            theme.palette.mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.08)' : '1px solid #e2e8f0',
          borderRadius: '30px',
          padding: '4px',
          gap: '4px',
          boxShadow: 'inset 0 1px 2px rgba(0, 0, 0, 0.02)',
        }}
      >
        <Button
          onClick={(e) => handleChange(e, 0)}
          variant="text"
          disableRipple
          sx={{
            borderRadius: '26px',
            textTransform: 'none',
            fontSize: '13px',
            fontWeight: 600,
            py: 0.75,
            px: 3.5,
            minWidth: 120,
            transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
            ...(value === 0
              ? {
                  backgroundColor: 'primary.main',
                  color: '#ffffff',
                  boxShadow: (theme) =>
                    theme.palette.mode === 'dark'
                      ? '0 2px 6px rgba(0, 0, 0, 0.4)'
                      : '0 2px 6px rgba(12, 77, 162, 0.3)',
                  '&:hover': {
                    backgroundColor: 'primary.main',
                  },
                }
              : {
                  color: 'text.secondary',
                  '&:hover': {
                    color: 'text.primary',
                    backgroundColor: 'transparent',
                  },
                }),
          }}
        >
          Announcement
        </Button>

        <Button
          onClick={(e) => handleChange(e, 1)}
          variant="text"
          disableRipple
          sx={{
            borderRadius: '26px',
            textTransform: 'none',
            fontSize: '13px',
            fontWeight: 600,
            py: 0.75,
            px: 3.5,
            minWidth: 120,
            transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
            ...(value === 1
              ? {
                  backgroundColor: 'primary.main',
                  color: '#ffffff',
                  boxShadow: (theme) =>
                    theme.palette.mode === 'dark'
                      ? '0 2px 6px rgba(0, 0, 0, 0.4)'
                      : '0 2px 6px rgba(12, 77, 162, 0.3)',
                  '&:hover': {
                    backgroundColor: 'primary.main',
                  },
                }
              : {
                  color: 'text.secondary',
                  '&:hover': {
                    color: 'text.primary',
                    backgroundColor: 'transparent',
                  },
                }),
          }}
        >
          Election Board
        </Button>
      </Box>
    </Box>
  );
}
